import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ABOUT_SAFA_LINK, CHANGELOG_LINK, FEEDBACK_LINK } from "@/util";
import { onboardingApiStore } from "@/hooks";
import { PanelCard, FlexBox, TextButton } from "@/components/common";

/**
 * Opens the onboarding workflow.
 */

/**
 * Provides links to external documentation.
 */
const __default__ = {
  name: "ExternalLinks",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleOnboarding(): void {
  onboardingApiStore.handleLoadOnboardingState("open");
}

/**
 * Routes the user to the feedback page.
 */
function handleFeedback(): void {
  window.open(FEEDBACK_LINK);
}

/**
 * Routes the user to the walkthrough page.
 */
function handleWalkthrough(): void {
  window.open(ABOUT_SAFA_LINK);
}

/**
 * Routes the user to the walkthrough page.
 */
function handleChangelog(): void {
  window.open(CHANGELOG_LINK);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { title: "SAFA Documentation" }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        "full-width": "",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), { column: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), {
                text: "",
                color: "gradient",
                label: "Generate Docs",
                icon: "generate-artifacts",
                onClick: handleOnboarding
              }),
              _createVNode(_unref(TextButton), {
                text: "",
                label: "About SAFA",
                icon: "nav-artifact",
                onClick: handleWalkthrough
              }),
              _createVNode(_unref(TextButton), {
                text: "",
                label: "Send Feedback",
                icon: "feedback",
                onClick: handleFeedback
              }),
              _createVNode(_unref(TextButton), {
                text: "",
                label: "Recent Changes",
                icon: "changelog",
                onClick: handleChangelog
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})